<template>
  <router-view />
</template>

<script setup lang="ts">
import { saveUrlParamsToStorage } from '@/utils/index'
import { onMounted } from 'vue'

onMounted(() => {
  saveUrlParamsToStorage()
})
</script>
